﻿$.fn.dxCtrlImageData = function custom_dxCtrlImageData(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlimagedata dx-ctrl");
        this.createInstance(new cdxCtrlImageData(this, option));
    }
    return this;
}

var lstImageData = []
window.cdxCtrlImageData = function (container, option) {
    var Me = this;

    //option.nb - nbre à afficher
    //option.libelle - texte à afficher
    //option.icone - icone à afficher
    //option.txtooltip - icone à afficher (%%nb%% à remplacer)
    //option.size - width et height du controle (carré)
    if (typeof option.searchStringImageWeb == 'undefined') option.searchStringImageWeb = ""
    if (typeof option.showTooltip == 'undefined') option.showTooltip = true
    if (typeof option.showTextOnImage == 'undefined') option.showTextOnImage = true
    if (typeof option.allowClick == 'undefined') option.allowClick = true
    if (typeof option.allowDisplayIcone == 'undefined') option.allowDisplayIcone = false

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var $DivContainerNb = null
    var $DivContainer = null
    function mConstruit() {
        $indicateur = null;
        container.empty();
        container.css({
            "height": option.size + "px",
            "width": option.size + "px"
        })

        $DivContainerNb = $("<div/>").appendTo(container)
        $DivContainerNb.css({
            "position": "relative",
            "height": "100%",
            "width": "100%"
        })

        $DivContainer = $("<div style='overflow:hidden' class='image'/>").appendTo($DivContainerNb)
        $DivContainer.css({
            "position": "relative",
            "height": "100%",
            "width": "100%",
            //border: theme.border,
            "background-color": "rgba(191, 191, 191, 0.3)",
            "overflow": "hidden",
            "border-radius": (option.size * 5 / 100) + "px"
        })

        mInitText()
        mInitToolTip()
        mInitIcone()
        mInitImage()

        if (typeof option.data != 'undefined') {
            var obj = option.bddCtrl.getObjet(option.data)
            option.id = obj.cle()
            option.id_table = obj.mGetTable().id_table
            $DivContainer.css("border-radius", option.bddCtrl.getObjet(option.data).mGetRadiusImage())
            mRempliText()
            mRempliTooltip()
            mRempliIcone()
            mRempliImage()
            mInitTrigger()
        } else if (typeof option.id != 'undefined') {
            mRempliImage()
            var nomTable = option.bddCtrl.table.mGetItem(option.id_table).nom
            option.bddCtrl.mAjaxCall({ command: "getdata", nomtable: nomTable, id: option.id }, function (data) {
                option.data = data[nomTable];
                $DivContainer.css("border-radius", option.bddCtrl.getObjet(option.data).mGetRadiusImage())
                mRempliText()
                mRempliTooltip()
                mRempliIcone()
                mInitTrigger()
                mDisplay()
            });
        } else {
            mRempliText()
            mRempliTooltip()
            mRempliIcone()
            mRempliImage()
            mDisplay()
        }

        if (option.allowClick || (typeof option.onClick != 'undefined' && option.onClick != null)) {
            container.css({
                "cursor": "pointer"
            })
            container.off("click")
            container.on("click", function (e) {
                e.stopPropagation()
                lstImageData = []
                if (typeof option.onClick != "undefined" && option.onClick != null) {
                    e.element = container;
                    option.onClick(e);
                } else {
                    if (srcImg == null || srcImg == "" || srcImg == option.srcImgDefaut) {
                        //var searchStringWeb = ((option.data) ? option.bddCtrl.getObjet(option.data).mGetLib1() : option.searchStringImageWeb)
                        var pop = $("<div/>").appendTo($DivGeneral).dxCtrlFileUploaderPopup({
                            bddCtrl: option.bddCtrl,
                            icone: option.allowDisplayIcone,
                            imgInternet: true,
                            multiple: false,
                            selectedItem: "machine",
                            accept: ".png,.jpg,.jpeg,.gif,.bmp",
                            optionImgInternet: {
                                bddCtrl: option.bddCtrl,
                                searchStringImageWeb: ((option.data) ? option.bddCtrl.getObjet(option.data).mGetLib1() : option.searchStringImageWeb)
                            },
                            onValide: function (lstUrlFile) {
                                if (lstUrlFile.length > 0) {
                                    jaugeDemarrage.mShow();
                                    (new cImage(option.bddCtrl)).mImgUrltoData64(lstUrlFile[0], function (dataUrl) {
                                        jaugeDemarrage.mHide()
                                        mCrop(dataUrl);
                                    },
                                        function () {
                                            jaugeDemarrage.mHide()
                                            mNotify("Impossible d'utiliser cette image", "error", 6000)
                                        })
                                }
                            }
                        }).dxCtrlFileUploaderPopup("instance")
                    } else {
                        mCrop(srcImg)
                    }
                }
            })
        }


        mAddFunctionOnModifiedTheme($DivIcone, function () { mConstruit() })

        if (typeof option.nb != 'undefined') {
            Me.mRempliCompteur(option.nb)
        }

        if (typeof option.data2 != 'undefined' && option.data2 != null) {
            var $Div2 = $("<div style='position:absolute;bottom:0;right:0;border-radius:50%;overflow:hidden;background-color:" + theme.backgroundcolorAccent + ";padding:2px;z-index:1;' class='image'/>").appendTo($DivContainer)
            var dxImageObjet = $("<div style='border-radius:50%;overflow:hidden;background-color:" + theme.backgroundcolorBase + "' class='image'/>").appendTo($Div2).dxCtrlImageData({
                bddCtrl: option.bddCtrl,
                data: option.data2,
                size: option.size * 40 / 100,
                searchStringImageWeb: "",
                showText: false,
                allowClick: false
            }).dxCtrlImageData("instance")
        }

    }

    function mInitTrigger() {
        if (typeof option.data != 'undefined') {
            var obj = option.bddCtrl.getObjet(option.data)
            option.bddCtrl.mAddFunctionOnModifiedItemData(obj.nomTable, $DivIcone, function (action, itemData) {
                if (typeof itemData != 'undefined' && obj.data[obj.nomCle] == itemData[obj.nomCle]) { mConstruit() }
            })
        }
    }

    var $DivText = null
    var nomTable = null
    function mInitText() {
        $DivText = $("<div style='position:absolute;bottom:0;width:100%;text-align:center;z-index:2;color:" + theme.backgroundcolorAccent + "'/>").appendTo($DivContainer)
        $DivText.css({
            "position": "absolute",
            "bottom": "0",
            "width": "100%",
            "text-align": "center",
            "z-index": "2",
            "color": theme.backgroundcolorAccent, //.backgroundcolorTooltip,
            "font-size": ((option.size * 15 / 100) * 2) + "px",
            "font-weight": "bold",
            "text-shadow": "0px 0px 2px " + theme.color,
            "line-height": 1
        })
        if (typeof option.fontSizeText != 'undefined') $DivText.css("font-size", option.fontSizeText)
    }
    function mRempliText() {
        $DivText.empty()
        if (typeof option.showText == 'undefined' || option.showText) {
            if (typeof option.noDataText != 'undefined') {
                $DivText.text(option.noDataText)
            } else if (typeof option.data != 'undefined') {
                if (typeof option.data2 != 'undefined') {
                    $DivText.text(option.bddCtrl.getObjet(option.data).mGetResume() + "/" + option.bddCtrl.getObjet(option.data2).mGetResume())
                } else {
                    $DivText.text(option.bddCtrl.getObjet(option.data).mGetResume())
                }

            }
        }
    }

    var dxCtrlToolTip = null
    function mInitToolTip() {
        if (option.showTooltip) {
            dxCtrlToolTip = $("<div/>").appendTo("body").dxCtrlTooltipHoverTarget({ target: container, visible: false, position: "bottom", contentTemplate: function (contentElement) { } }).dxCtrlTooltipHoverTarget("instance");
        }
    }
    function mRempliTooltip() {
        if (option.showTooltip) {
            if (typeof option.data != 'undefined') {
                dxCtrlToolTip.option("contentTemplate", function (contentElement) { $("<div style='font-size:110%;'>" + option.bddCtrl.getObjet(option.data).mGetLib1() + "</div>").appendTo(contentElement); });
            } else if (typeof option.txtooltip != 'undefined') {
                dxCtrlToolTip.option("contentTemplate", function (contentElement) { $("<div style='font-size:110%;'>" + option.txtooltip.replace("%%nb%%", option.nb) + "</div>").appendTo(contentElement); });
            } else {
                dxCtrlToolTip.remove()
            }
        }
    }

    var $DivIcone = null
    function mInitIcone() {
        $DivIcone = $("<div/>")
        $DivIcone.css({
            "position": "absolute",
            "z-index": "0",
            "display": "flex",
            "align-items": "center",
            "justify-content": "center",
            "width": "100%",
            "height": "100%"
        })
        $DivIcone.appendTo($DivContainer)
    }
    function mRempliIcone() {
        $DivIcone.empty()
        if (typeof option.rempliIcone == 'undefined' || option.rempliIcone) {
            if (typeof option.data != 'undefined') {
                option.bddCtrl.getObjet(option.data).mGetIcone().appendTo($DivIcone)
            } else {
                $("<i class='" + option.icone + "'></i>").appendTo($DivIcone)
            }
            $DivIcone.find("i").first().css({
                "text-align": "center",
                "font-size": (option.size * 74 / 100) + "px"
            })
        }
    }

    var $Img = null
    var srcImg = null
    function mInitImage() {
        $Img = $("<img style='position:absolute;z-index:1;display:none;max-width:none;'/>").appendTo($DivContainer)
        $Img.onLoad = imgOnLoad
    }
    function imgOnLoad() {
        var naturalWidth = $Img[0].naturalWidth
        var naturalHeight = $Img[0].naturalHeight
        var widthDiv = container.innerWidth()
        var heightDiv = container.innerHeight()
        var newHeight = null
        var newWidth = null
        var top = null
        var left = null
        if (widthDiv > heightDiv) {
            if (naturalWidth > naturalHeight) {
                newWidth = naturalWidth / naturalHeight * heightDiv
                newHeight = heightDiv
            } else {
                newHeight = naturalHeight / naturalWidth * widthDiv
                newWidth = widthDiv
            }
            top = (heightDiv - newHeight) / 2
            left = 0
        } else {
            if (naturalWidth > naturalHeight) {
                newWidth = naturalWidth / naturalHeight * heightDiv
                newHeight = heightDiv
            } else {
                newHeight = naturalHeight / naturalWidth * widthDiv
                newWidth = widthDiv
            }
            top = 0
            left = (widthDiv - newWidth) / 2
        }
        $Img.css({ "height": newHeight + "px", "width": newWidth + "px" })
        $Img.css({ "top": top + "px", "left": left + "px" })
        $Img.show()
    }
    function mRempliImage() {
        if (typeof option.id != 'undefined' && option.id != null) {
            var imgData = lstImageData.filter(function (o) { return o.id_table == option.id_table && o.id == option.id })[0]
            if (imgData && Math.abs((new Date()) - imgData.dat) > 90000) {
                lstImageData.splice(lstImageData.indexOf(imgData), 1)
                imgData = null;
            }
            if (imgData) {
                srcImg=imgData.src
                $Img.off("load").on("load", imgOnLoad);
                $Img.attr("src", imgData.src)
                if ($Img[0].complete) {
                    imgOnLoad();
                }
                mDisplay()
            } else {
                option.bddCtrl.getObjet(option.bddCtrl.table.mGetItem(option.id_table).nom, option.id).mGetData64Image(function (data64img) {
                    if (data64img.length > 0) {
                        srcImg = data64img;
                    } else {
                        srcImg = ((option.srcImgDefaut) ? option.srcImgDefaut : "")
                    }
                    if (lstImageData.filter(function (o) { return o.id_table == option.id_table && o.id == option.id }).length == 0) lstImageData.push({
                        dat: new Date(),
                        id_table: option.id_table,
                        id: option.id,
                        src: srcImg
                    })
                    $Img.off("load").on("load", imgOnLoad);
                    $Img.attr("src", srcImg)
                    if ($Img[0].complete) {
                        imgOnLoad();
                    }
                    mDisplay()
                })
            }

        } else { mDisplay() }
    }

    function mDisplay() {
        if (srcImg != null && srcImg.length > 0) {
            $DivIcone.hide()
            $Img.show()
            if (!option.showTextOnImage) $DivText.hide()
        } else {
            $DivIcone.css("display", "flex")
            $Img.hide()
            $DivText.show()
        }
    }

    var $indicateur = null;
    this.mRempliCompteur = function (value) {
        option.nb = parseInt(value)
        if (!$indicateur) {
            var topRight = option.size * -8 / 100
            var size = option.size * 30 / 100
            var fontSize = option.size * 20 / 100
            $indicateur = $("<div style='position:absolute;top:" + topRight + "px;right:" + (topRight - 3) + "px;display:none;z-index:2;'><div style='border-radius:50%;padding:2px;font-weight:bold;background-color:red;height:" + size + "px;width:" + size + "px;opacity:0.8;font-size:" + fontSize + "px;line-height:110%;display:flex;align-items:center;justify-content:center;'></div></div>").appendTo($DivContainerNb)
        }
        if (option.nb > 0) {
            if ($indicateur.is(":visible")) {
                $indicateur.fadeOut(250, "swing", function () {
                    if (option.nb > 99) { $($indicateur.find("div")).html("<i class='fas fa-infinity' title='" + option.nb + "'></i>") }
                    else { $($indicateur.find("div")).text(option.nb) }
                    $indicateur.fadeIn(250);
                });
            }
            else {
                if (option.nb > 99) { $($indicateur.find("div")).html("<i class='fas fa-infinity' title='" + option.nb + "'></i>") }
                else { $($indicateur.find("div")).text(option.nb) }
                $indicateur.fadeIn(300);
            }
        } else {
            $indicateur.fadeOut(300);
        }
    }

    var dataImage = null;
    function mCrop(dataImg) {
        var opt = {
            url: dataImg,
            formatImage: "jpg",
            enableOrientation: true,
            onAnnulation: function (e) { e.component.hide(); },
            onValidation: function (e) {
                //on a sauvegardé l'image en jpg
                if (option.id == null) {
                    option.bddCtrl.getObjet(option.data).mSave(function (data) {
                        option.id = data.id
                        mSaveImage()
                    })
                } else { mSaveImage() }

                function mSaveImage() {
                    srcImg = e.component.dataImage
                    mDisplay()
                    popCrop.hide();
                    option.bddCtrl.mAjaxCall({
                        command: "saveimgdata",
                        id_table: option.id_table,
                        id: option.id,
                        dataimg: srcImg
                    }, function (data) {
                        var obj = option.bddCtrl.getObjet(option.data)
                        option.bddCtrl.triggerFunctionOnModifiedItemData(obj.mGetTable().nom, "modif", option.data)
                    }, function () {
                    }, function () {
                    });
                }
            }
        }
        if (srcImg != "" && srcImg != option.srcImgDefaut) {
            opt.onSuppression = function (funcOk, funcAlways, funcKo) {
                srcImg = ""
                mDisplay()
                option.bddCtrl.mAjaxCall({
                    command: "delimgdata",
                    id_table: option.id_table,
                    id: option.id
                }, function (data) {
                    var obj = option.bddCtrl.getObjet(option.data)
                    option.bddCtrl.triggerFunctionOnModifiedItemData(obj.mGetTable().nom, "modif", option.data)
                }, function () {
                }, function () {
                });
                popCrop.hide();
            }
        }
        var popCrop = $("<div/>").appendTo($DivGeneral).dxCtrlPopupCrop(opt).dxCtrlPopupCrop("instance")
        popCrop.show();
    }

    this.element = function () { return container; }

    mConstruit();
}